// Single source of truth for which personas may be picked in selectors.
//
// A persona is selectable when it is "active" OR "draft" — drafts are
// deliberately included so a just-created persona can be used immediately.
// Only "archived" (and any future non-selectable status) is excluded. This was
// extracted from the inline filter in client/src/pages/narratives.tsx so the
// rule is unit-testable and can't silently drift to (e.g.) "active"-only, which
// would make drafts vanish from the persona picker.
// `server/__tests__/brandPersonaConfig.test.ts` locks the behavior in.

export function isSelectablePersona(status: string | null | undefined): boolean {
  return status === "active" || status === "draft";
}

export function selectablePersonas<T extends { status?: string | null }>(
  personas: T[],
): T[] {
  return personas.filter((p) => isSelectablePersona(p.status));
}
